export const buildNumber = '20260415.2';
export const version = 'main';
export const latestCommit = '5c20b77039e5fbcd4d95f2a08af68e8725e20144';
